import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialogRef } from '@angular/material/dialog';
import { ClientView } from '../../../../../../../core/model/client-view.model';
import { ClientService } from '../../client/client.service';

@Component({
  selector: 'app-select-debtor-dialog',
  templateUrl: './select-debtor-dialog.component.html',
  styleUrls: ['./select-debtor-dialog.component.scss'],
})
export class SelectDebtorDialogComponent implements OnInit {
  clientForm: UntypedFormGroup;
  clients: ClientView[] = [];
  filteredClients: ClientView[] = [];

  selectedDebtorId: number;

  constructor(
    private _clientService: ClientService,
    private _dialogRef: MatDialogRef<SelectDebtorDialogComponent>,
    private _formBuilder: UntypedFormBuilder,
  ) {
  }

  ngOnInit() {
    this.clientForm = this._formBuilder.group({
      clientPicker: new UntypedFormControl({ value: '' }),
    });

    this._clientService.list(0, 999).subscribe(res => {
      this.clients = res.data;
      this.filteredClients = this.clients;
    });

    this.clientForm.get('clientPicker').valueChanges.subscribe(value => {
      if (!(value instanceof Object)) {
        this.selectedDebtorId = null;
      }
      if (value) {
        this.filteredClients = this.autocompleteFilterDebtors(value);
      } else {
        this.filteredClients = this.autocompleteFilterDebtors('');
      }
    });

    this.clientForm.reset();
  }

  autocompleteFilterDebtors(value: ClientView | string): any[] {
    let toSearch = '';
    toSearch = typeof value === 'string' ? value.toLocaleLowerCase() : value.businessName.toLocaleLowerCase();

    return this.clients.filter(
      d => d.businessName.toLocaleLowerCase().includes(toSearch) || d.taxCode.includes(toSearch),
    );
  }

  autocompleteDisplay(value: ClientView): string | undefined {
    return value ? `${value.businessName} - ${value.taxCodePrefix} ${value.taxCode}` : undefined;
  }

  autocompleteSelect(selectedEvent: MatAutocompleteSelectedEvent): void {
    const selectedValue: ClientView = selectedEvent.option.value;
    this.selectedDebtorId = selectedValue.debtorId;
  }

  resetDebtorForm(): void {
    this.clientForm.reset();
  }

  onSubmit(): void {
    this._dialogRef.close(this.selectedDebtorId);
  }
}
